module.exports = __webpack_public_path__ + "img/wave-02.6e3e25d9.svg";